module.exports = __webpack_public_path__ + "static/media/lottery_pc_bg.45f5d3aa.png";